import {h, Component} from 'preact';

import Icon from '@components/common/Icon';
import {TextField} from '@components/common/Form/TextField';

class PasswordShowHide extends Component {
    state = {
        hidden: true
    };

    toggleShow () {
        this.setState( {hidden: !this.state.hidden} );
    }

    render ( {handleChange, value, errors} ) {
        const {hidden} = this.state;
        return (
            <div className="passwordShowHide">
                <TextField
                    type={hidden ? 'password' : 'text'}
                    name="password"
                    value={value}
                    onChange={handleChange}
                    inputClassName="w-full"
                    className="inline-block w-full"
                    error={errors.password}
                    id="password"/>
                <Icon.ui
                    center
                    data-tooltip={`${hidden ? 'Show password' : 'Hide password'}`}
                    wrapperClassName="flex justify-center items-center"
                    className="text-xl"
                    name={`${hidden ? 'eye-open' : 'eye-closed'}`}
                    onClick={this.toggleShow.bind( this )}/>
            </div>
        );
    }
}

export default PasswordShowHide;